export default __webpack_public_path__ + "static/media/en-icon.42fc29f9.svg";